import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

import type { BasicParametersStore } from '../BasicParameters.store';

import styles from '../BasicParameters.module.scss';

import { ActionsButtons } from './ActionsButtons';
import { LogsIndexSwitcher } from './LogsIndexSwitcher';

type Props = {
  store: BasicParametersStore;
  disabled: boolean;
};

export const ActionsPanel = observer(function ActionsPanel({ store, disabled }: Props) {
  return (
    <div className={clsx(styles.actionsPanel, disabled && styles.actionsPanel__disabled)}>
      <LogsIndexSwitcher store={store} />
      <ActionsButtons store={store} />
    </div>
  );
});
